module.exports = __webpack_public_path__ + "static/media/du-admission-language-courses.d2abcc27.jpeg";